import OrdersGroup from "@/views/admin/order/OrdersGroup";

export default {
  path: "orders-group/:id",
  name: "OrdersGroup",
  component: OrdersGroup,
  props: true,
  meta: {
    requiresAuth: true
  }
};
